import TopFxLayer from '../Elements/GameState/UI/Layers/TopFxLayer';

G.BoardCandies = function(board,data, lvl, regularTypesNumber, editorMode) {
		
	Phaser.Group.call(this,game);
	this.board = board;

  this.editorMode = editorMode;
  this.postRandomPhase = false;

	this.position = board.position;
	this.scale = board.scale;

	this.regularTypesNumber = regularTypesNumber;	

	this.boardData = data;

	this.grid = new G.GridArray(this.boardData.width,this.boardData.height,false);

	this.deadGroup = game.add.group();
	this.deadGroup.visible = false;

	this.firstFloor = game.add.group();
	this.secondFloor = game.add.group();

	this.fxGroup = new TopFxLayer(this.board);

	this.boosterFxGroup = game.add.group();

	this.thirdFloor = game.add.group();

	this.fxTopGroup = this.fxGroup.aboveThirdFloorLayer = game.add.group();

	if (G.IMMEDIATE) {
		this.deadGroup.visible = this.firstFloor.visible = this.secondFloor.visible = this.fxGroup.visible = this.thirdFloor.visible = this.fxTopGroup.visible = false;
	}

	this.firstFloor.position = this.secondFloor.position = this.fxGroup.position = this.fxTopGroup.position = this.boosterFxGroup.position = this.thirdFloor.position = this.position;
	this.firstFloor.scale = this.secondFloor.scale = this.fxGroup.scale = this.fxTopGroup.scale = this.boosterFxGroup.scale = this.thirdFloor.scale = this.scale;

	//this.addMultiple([this.firstFloor,this.secondFloor,this.fxGroup,this.thirdFloor]);

	this.infectionSources = [];
	this.infectionSuperSources = [];
	this.infectionCoords = [
	[-1,0],
	[1,0],
	[0,-1],
	[0,-1],
	[-1,-1],
	[-1,-1],
	[1,-1],
	[1,1]
	];

	G.sb("onCandyInfect").add(function(candy) {
		this.addInfectionSource(candy,this.infectionSources);
	},this);
	G.sb("onCandyInfectionRemove").add(function(candy) {
		this.removeInfectionSource(candy,this.infectionSources);
	},this);


	this.removedInfectionSource = false;
	this.infectionToMakeStep = 0;


	G.sb("actionQueueEmptyAfterMove").add(function() {
		if (!this.removedInfectionSource) {
			if (this.infectionSuperSources.length > 0) {
				var spreaded = this.spreadInfection(this.infectionSuperSources);
				if (!spreaded) {
					this.spreadInfection(this.infectionSources);
				}
			}
		}
		this.removedInfectionSource = false;
	},this);

};


G.BoardCandies.prototype = Object.create(Phaser.Group.prototype);

G.BoardCandies.prototype.getAllTokensWithTag = function (tag) {
	return this.getAllCandies().filter(function (candy) {
		return candy.hasTag(tag);
	});
};

G.BoardCandies.prototype.onMatch = function(cellX, cellY, delay, moveCellX, moveCellY) {
	var candy = this.getCandy(cellX, cellY);
	if (candy) {
		candy.match(delay, moveCellX, moveCellY);
	}
	return true;
};

G.BoardCandies.prototype.onHit = function(cellX, cellY) {
	var candy = this.getCandy(cellX, cellY);
	if (candy) {
    	return candy.hit();
	}
	return true;
};

G.BoardCandies.prototype.onBooster = function(cellX, cellY) {
  var candy = this.getCandy(cellX, cellY);
  if (candy) {
    return candy.onBooster();
  }
  return true;
};

G.BoardCandies.prototype.isMoveBlocked = function(cellX, cellY) {
	return false;
};

G.BoardCandies.prototype.isMatchBlocked = function(cellX, cellY) {
	var candy = this.getCandy(cellX, cellY);
	if (candy) {
		return !candy.isMatchable();
	} else {
		return true;
	}
};

G.BoardCandies.prototype.isCandyMatchableWith = function(cellX, cellY, optCandy) {
	var candy = this.getCandy(cellX, cellY);
	if (candy) {
		return candy.isMatchableWith(optCandy);
	} else {
		return false;
	}
};

G.BoardCandies.prototype.isBoosterChangeBlocked = function(cellX, cellY) {
	var candy = this.getCandy(cellX, cellY);
	if (candy) {
		return candy.hasSpecialType() || candy.hasStatus();
	} else {
		return false;
	}
};

G.BoardCandies.prototype.import = function(cellX, cellY, chunk) {
	var candy = this.newCandy(cellX, cellY, chunk);
};

G.BoardCandies.prototype.export = function(cellX, cellY) {
	var candy = this.getCandy(cellX, cellY);
	if (candy) {
		return candy.export();
	}

	return false;
};

G.BoardCandies.prototype.spreadInfection = function(sourcesArray) {

	if (sourcesArray.length == 0) return; 

	Phaser.ArrayUtils.shuffle(sourcesArray);
	var source = game.rnd.pick(sourcesArray);
	for (var i = 0, len = this.infectionCoords.length; i < len; i++) {
		var coords = this.infectionCoords[i];
		var xx = source.cellX+coords[0];
		var yy = source.cellY+coords[1];
		var candyToInfect = this.getCandy(xx,yy);

		if (!candyToInfect) continue;
		if (!this.board.isMoveable(xx,yy)) continue;
		if (!this.board.isCellMatchable(xx,yy)) continue;
		if (candyToInfect.hasStatus()) continue;
		if (candyToInfect.hasSpecialType()) continue;

		// G.sb("onCollectableAdded").dispatch("infection");
		candyToInfect.setStatus(G.Helpers.candyDataMgr.getStatusByEditorSymbol("I"));
		return true;
	}

	return false;

};

G.BoardCandies.prototype.getRandomNormal = function() {

	var children = this.firstFloor.children.concat(this.secondFloor.children);

	var len = children.length;
	var rnd = game.rnd.between(0,len);
	var piece;

	if (len == 0) return false;

	for (var i = 0; i < len; i++) {
		piece = children[(i+rnd)%len];
		if (this.grid.get(piece.cellX,piece.cellY) == piece) {

			if (piece && !piece.hasSpecialType()
				&& !piece.chocolate
				&& !piece.hasStatus()
				&& piece.alive
				&& !piece.isGoalCandy()
				&& !piece.isBurntCandy()
				&& this.board.isCellMatchable(piece.cellX,piece.cellY)
				&& this.board.isMoveable(piece.cellX,piece.cellY)) {
				return piece;
			}

		}
	}

	return false;

};


// TODO: rename that
G.BoardCandies.prototype.getNormalCandies = function() {

	var children = this.firstFloor.children.concat(this.secondFloor.children);

	var len = children.length;
	var rnd = game.rnd.between(0,len);
	var piece;

	var result = [];

	if (len == 0) return false;

	for (var i = 0; i < len; i++) {

		piece = children[(i+rnd)%len];
		if (this.grid.get(piece.cellX,piece.cellY) == piece) {

      // TODO: replace all that stuff
			if (piece && !piece.hasSpecialType()
        && !piece.hasStatus()
        && piece.alive
				&& !piece.isGoalCandy()
				&& !piece.isBurntCandy()
        && this.board.isCellMatchable(piece.cellX,piece.cellY)
        && this.board.isMoveable(piece.cellX,piece.cellY)
				// quick hack to stop changing chest into special at the end of level
				&& !piece.hasTag("chest")
				&& !piece.hasTag("fortune")) {
				result.push(piece);
			}

		}
	}

	return result;



};



G.BoardCandies.prototype.moveTo = function(x,y) {

	this.x = x;
	this.y = y;

	//this.firstFloor.x = this.secondFloor.x = this.fxGroup.x = this.fxTopGroup.x = this.boosterFxGroup.x = this.thirdFloor.x = x;
	//this.firstFloor.y = this.secondFloor.y = this.fxGroup.y = this.fxTopGroup.y = this.boosterFxGroup.y = this.thirdFloor.y = y;
};

G.BoardCandies.prototype.isSpaceFree = function(cellX,cellY) {
	return !this.grid.get(cellX,cellY);
};

G.BoardCandies.prototype.gridMoveFromTo = function(cellX,cellY,newCellX,newCellY) {

	this.grid.set(newCellX,newCellY,this.grid.get(cellX,cellY));
	this.grid.set(cellX,cellY,null);

};

G.BoardCandies.prototype.getFreeInstanceOfCandy = function() {
  var candy;
  if (this.deadGroup.children[0]) {
    candy = this.deadGroup.children[0];
  } else {
    candy = new G.Candy(this.board, this.grid, this.postRandomPhase);
  }
  return candy;
};


G.BoardCandies.prototype.newCandy = function(x,y,type) {
	var candy = this.getFreeInstanceOfCandy();
	this.firstFloor.add(candy);

	
	candy.init(x,y,type || game.rnd.between(1,this.board.MAX_NUMBER_OF_REGULAR_CANDY));
	this.grid.set(x,y,candy);
	
  // TODO: move it to candy
	if (type == "infection") {
		//this.infectionSources.push(candy);
		this.addInfectionSource(candy,this.infectionSuperSources);
	}

	return candy;
};

G.BoardCandies.prototype.replaceRandomCandies = function() {
  var self = this;
	var types = G.Helpers.candyDataMgr.getTypesWithTag("regular").slice(0, this.regularTypesNumber);

	this.grid.loop(function(candy, x, y, gridData) {
		if (!candy) return;
		if (!candy.isRandom()) return;

		let timeoutCounter = 0;
		let isSet = false;
		while (!isSet && timeoutCounter < 300) {
			const rndIndexOffset = game.rnd.between(0, this.regularTypesNumber-1);
			const chosenGem = types[rndIndexOffset%types.length];
			candy.setBaseType(chosenGem);
			if (!checkIfThereIsMatch(candy, x, y)) {
				isSet = true;
			}
			timeoutCounter++;
		}
	}, this);

  this.grid.loop(function(candy, x, y) {
    if (!candy) return;

    if (candy.hasStatus()
      && candy.candyStatus.getEditorSymbol() === "bx") {

      if (candy.candyStatus.boxColor === "r") {
        var rndIndexOffset = game.rnd.between(0, this.regularTypesNumber-1);
        for (var i = 0; i <= this.regularTypesNumber; i++) {
          candy.candyStatus.setMatchToken(types[(rndIndexOffset+i)%types.length].candyType);
          if (checkIfThereIsMatch(candy, x, y)) {
              continue;
          } else {
            break;
          }
        }
      }
    }
    
    candy.markPostRandomPhase();
  }, this);

  function checkIfThereIsMatch(candy, x, y) {
    return (self.isCandyMatchableWith(x-2,y,candy) && self.isCandyMatchableWith(x-1,y,candy)) // 1 1 [x]
      || (self.isCandyMatchableWith(x,y-2,candy) && self.isCandyMatchableWith(x,y-1,candy)) // 1 1 [x] (vertically)
			|| (self.isCandyMatchableWith(x-1,y,candy) && self.isCandyMatchableWith(x-1,y-1,candy) && self.isCandyMatchableWith(x,y-1,candy)) // ??
			|| (self.isCandyMatchableWith(x-1, y, candy) && self.isCandyMatchableWith(x+1, y, candy)) // 1 [x] 1
			|| (self.isCandyMatchableWith(x, y-1, candy) && self.isCandyMatchableWith(x, y+1, candy)) // 1 [x] 1 (vertically)
			|| (self.isCandyMatchableWith(x+1, y, candy) && self.isCandyMatchableWith(x+2, y, candy)) // [x] 1 1
			|| (self.isCandyMatchableWith(x, y+1, candy) && self.isCandyMatchableWith(x, y+2, candy)) // [x] 1 1 (vertically)
  }

  // this.postRandomPhase = true;
  // this.grid.loop(function(candy) {
  //   if (candy) candy.markPostRandomPhase();
  // });
};

G.BoardCandies.prototype.getToken = function(cellX, cellY) {
  return this.grid.get(cellX, cellY);
}

G.BoardCandies.prototype.getCandy = function(cellX,cellY) {
	return this.grid.get(cellX,cellY);
};

G.BoardCandies.prototype.swapCandies = function(c1,c2) {

	this.grid.set(c1.cellX,c1.cellY,c2);
	this.grid.set(c2.cellX,c2.cellY,c1);

	var tmpX = c1.cellX;
	var tmpY = c1.cellY;
	c1.cellX = c2.cellX;
	c1.cellY = c2.cellY;
	c2.cellX = tmpX;
	c2.cellY = tmpY;

};

G.BoardCandies.prototype.removeCandy = function() {

	var candy;
  var skipCollectableRemove = false;

  if (typeof arguments[0] === "object") {
    if (Array.isArray(arguments[0])) {
      // passed cellX and cellY as array
      candy = this.getCandy(arguments[0][0], arguments[0][1]);
    } else {
      // passed candy
      candy = arguments[0];
    }
    skipCollectableRemove = arguments[1];
  } else {
    //passed cellX and cellY
    candy = this.getCandy(arguments[0], arguments[1]);
    skipCollectableRemove = arguments[2];
  }

	if (candy) {
		this.removeInfectionSource(candy,this.infectionSuperSources);

    this.grid.set(candy.cellX, candy.cellY, false);

		if (!skipCollectableRemove) {
      candy.dispatchCollectables();
    };
		
		candy.kill();
		this.deadGroup.add(candy);
	}

};

G.BoardCandies.prototype.removeToken = G.BoardCandies.prototype.removeCandy;

G.BoardCandies.prototype.destroyCell = G.BoardCandies.prototype.removeCandy;

G.BoardCandies.prototype.addInfectionSource = function(candy,sourcesArray) {

	if (sourcesArray.indexOf(candy) === -1) {
		sourcesArray.push(candy);
	}


};

G.BoardCandies.prototype.removeInfectionSource = function(candy,sourcesArray) {

	var index = sourcesArray.indexOf(candy);
	if (index !== -1) {
		sourcesArray.splice(index,1);
		this.removedInfectionSource = true;
	}

};

G.BoardCandies.prototype.consoleInfectionSources = function() {

	for (var i = 0; i < this.infectionSources.length; i++) {
		console.log("INFECTION SOURCE: "+this.infectionSources[i].cellX+'x'+this.infectionSources[i].cellY);
	}

};

G.BoardCandies.prototype.getAllSpecialCandies = function() {

	var result = [];

	this.grid.loop(function(elem,x,y) {
		if (elem && elem.hasSpecialType()) result.push(elem);
	});

	return result;

};


G.BoardCandies.prototype.deconstruct = function() {

	var delay = 0;

	for (var i = 0; i <= 20; i++) {
		var xx = 0;
		for (var yy = i; yy >= 0; yy--) {
			if (this.grid.get(xx,yy)) {
				t1 = game.add.tween(this.grid.get(xx,yy).scale).to({x:0,y:0},300,Phaser.Easing.Sinusoidal.InOut,true,delay);
			}
			xx++;
			
		}
		delay += 40;
		//delay += 70;
	}

};

G.BoardCandies.prototype.areCandiesNeighbours = function(candy, candy2) {
  if (!candy || !candy2) return false;
  return (Math.abs(candy.cellX - candy2.cellX) + Math.abs(candy.cellY - candy2.cellY)) == 1;
};

G.BoardCandies.prototype.getAllCandies = function() {
	var result = [];
	this.grid.loop(function(candy) {
		if (candy) result.push(candy);
	});
	return result;
};

G.BoardCandies.prototype.countEditorSymbolOccurrence = function(symbol) {
	return this.getAllCandies().filter(function(candy) {
		return candy.hasEditorSymbol(symbol);
	}).length;
};

G.BoardCandies.prototype.countExportStringOccurrence = function(str) {
  return this.getAllCandies().filter(function(candy) {
    return candy.hasExportString(str);
  }).length;
};